import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-language',
  templateUrl: './language.component.html',
  styleUrls: ['./language.component.scss']
})

export class LanguageComponent implements OnInit{
  isGerman: boolean = false;
  isEnglish: boolean= false;

  constructor(){}

  ngOnInit(): void {
    if ($localize.locale === 'en-US') {
      this.isEnglish = true;
    }
    else {
      this.isGerman = true;
    }
  }

  changeLanguage(language:string) {
    if (language === 'DE') {
      window.location.replace(
        `${window.location.origin}/adminPortal/de/${window.location.hash}`
      );
      this.isEnglish = false;
      this.isGerman = true;
    }
    else {
      window.location.replace(
        `${window.location.origin}/adminPortal/en-US/${window.location.hash}`
      );
      this.isGerman = false;
      this.isEnglish = true;
    }
  }
}
